import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { MediaType } from 'libs/shared-logic/src/graphql/enums';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router';
import { NewIssueModal, NewIssueModalProps } from '../../issues';
import { AddButton } from '../../shared/components/addButton/addButton';

export const AssetFiltersOld = ({
  assetId,
  workspaceId,
}: {
  assetId: string;
  workspaceId: string;
}) => {
  const [issueModalVisible, setIssueModalVisible] = useState(false);
  const [newIssueModalProps, setNewIssueModalProps] = useState<
    NewIssueModalProps | undefined
  >(undefined);
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();

  const onIssueComplete = () => {
    setIssueModalVisible(false);
  };
  
  const onAssetEdit = async () => {
    if (!location.pathname.includes('activity')) {
      await onSlideChange(SlideAction.NEXT);
    }
    
    navigate(`/assets/${assetId}/edit`);
  };

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit}>
        <Icon name="Settings" size={24} />
      </Pressable>
      <AddButton
        onPress={() => {
          setNewIssueModalProps({
            assetId: assetId,
            workspaceId: workspaceId,
            isOpened: issueModalVisible,
            modalType: 'modal',
            onComplete: onIssueComplete,
          });
          setIssueModalVisible(true);
        }}
      />
      
      {newIssueModalProps && (
        <NewIssueModal
          {...newIssueModalProps}
          isOpened={issueModalVisible}
          acceptedMediaTypes={[MediaType.Image, MediaType.Document]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
